//import logo from './logo.svg';

import './App.css';

/*
function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.js</code> and save to reload.
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      </header>
    </div>
  );
}
*/



//import './Components/HomePage';
import HomePage from './Components/HomePage/HomePage';

function App() {
  return (
    <div className="App">
      <meta name='test' content='width = device-width, initial-scale=1.0,userscalable=no'></meta>
      <HomePage/>
    </div>
  );
}

export default App;
